let accordion = () => {

    let module = {},
        accOpener,
        accBody,
        accImage,
        $window,
        htmlbody,

        attachEvents = () => {

            $('.active-item').find(accBody).show();

            accOpener.on('click', (e) => {
                var elParent = $(e.currentTarget).parent();
                var accordionItemIndex = elParent.data('accordionItem');

                accImage.removeClass('active-picture');
                $(`[data-accordion-image="${accordionItemIndex}"]`).addClass('active-picture');

                if (!elParent.hasClass('active-item')) {
                    accOpener.parent().removeClass('active-item');
                    accOpener.next(accBody).slideUp('slow');
                    elParent.addClass('active-item');
                    elParent.find(accBody).slideDown('slow');
                }

                if ($window.width() < 992) {
                    window.setTimeout(function () {
                        var parY = elParent.offset().top;
                        htmlbody.animate({
                            scrollTop: parY
                        }, 650);
                    }, 650);
                }

            });

        },

        init = () => {
            $window = $(window);
            htmlbody = $('html,body');
            accOpener = $('.js-accordion-opener');
            accBody = $('.js-accordion-body');
            accImage = $('.js-accordion-picture');


            attachEvents();
        };

    module.init = init;

    return module;
}

export default accordion();